<template>
  <lottie
    :height="height"
    :width="width"
    :options="lottieOptions"
    @animCreated="handleAnimation"
  />
</template>

<script>
import lottie from 'vue-lottie/src/lottie.vue'

export default {
  name: 'LottiePlayer',

  // Components
  components: {
    lottie
  },

  props: {
    height: {
      type: Number,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    animationData: {
      required: true,
      type: Object
    },
    loop: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    lottieOptions () {
      return {
        animationData: this.animationData,
        autoplay: false,
        loop: this.loop
      }
    }

  },

  methods: {
    handleAnimation (animation) {
      this.animation = animation
      this.animation.play()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
